export type AccessOverviewPhase = 'idle' | 'loading' | 'ready' | 'error';

export type AccessOverviewTab = 'dashboard' | 'graph' | 'roles';

export interface AccessOverviewState {
    phase: AccessOverviewPhase;
    userId: string | null;
    firmId: string | null;
    error: string | null;
    selectedNodeId: string | null;
    searchQuery: string;
    activeTab: AccessOverviewTab;
}

export const initialAccessOverviewState: AccessOverviewState = {
    phase: 'idle',
    userId: null,
    firmId: null,
    error: null,
    selectedNodeId: null,
    searchQuery: '',
    activeTab: 'dashboard',
};
